// =============================================================================
// SaveStatusPill — autosave indicator
// =============================================================================
// Props: { status: 'idle'|'saving'|'saved'|'error', lastSavedAt, onRetry }

function relativeTime(date) {
  const diff = Math.round((Date.now() - new Date(date).getTime()) / 1000);
  if (diff < 5) return 'just now';
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  return `${Math.round(diff / 3600)}h ago`;
}

export default function SaveStatusPill({ status, lastSavedAt, onRetry }) {
  if (status === 'idle') return null;

  if (status === 'saving') {
    return (
      <span className="text-xs font-bold text-silver-mute bg-gray-100 px-3 py-1 rounded-full">
        Saving…
      </span>
    );
  }

  if (status === 'saved' && lastSavedAt) {
    return (
      <span className="text-xs font-bold text-mid-green bg-green-50 border border-green-200 px-3 py-1 rounded-full">
        Saved {relativeTime(lastSavedAt)}
      </span>
    );
  }

  if (status === 'error') {
    return (
      <button
        type="button"
        onClick={onRetry}
        className="text-xs font-bold text-red-600 bg-red-50 border border-red-200 px-3 py-1 rounded-full hover:bg-red-100 transition-colors"
      >
        Save failed — click to retry
      </button>
    );
  }

  return null;
}
